import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { get_z3k_object_state } from 'z3k-config';
import { Box, Typography } from '@mui/material';
import { RadioRegistrationButton } from 'console/climatic/setting-tabs/digital-sensors/registration-button';
import { ClimaticDigitalSensorType } from 'console/climatic/setting-tabs/digital-sensor-type';
import { useDigitalSensorsState } from 'z3k-settings/climatic/digital-sensors/lib/useDigitalSensorsState';
import { Z3KSettings, Z3KSettingsEditor, Z3KSettingsState, } from 'z3k-settings/provider/types';
import { useCallback, useContext, useState } from 'react';
import { useConfirmDialog } from 'shared/hooks/ui';
import { useDispatch } from 'react-redux';
import { send_z3k_command } from 'z3k-settings/redux/actions';
import { SensorsTable } from 'z3k-settings/climatic/digital-sensors/ui/sensors-table';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { selectDevice } from 'entities/device/lib';
import { default_settings_from_sensor } from 'console/climatic/setting-tabs/digital_sensors';
import { unpack_validation } from 'z3k-parser/validation/types';
import { SettingCard } from 'z3k-settings/components/material-utils/settings-card';
export function ClimaticDigitalSensors() {
    const { radiomodule, sensor_settings, deleted_sensor_ids, circuit_options } = useDigitalSensorsState();
    const { device_id } = useContext(Z3KSettings);
    const { z3k_state } = useContext(Z3KSettingsState);
    const { config, replace_config } = useContext(Z3KSettingsEditor);
    const device = usePartialAppSelector(selectDevice, device_id);
    const dispatch = useDispatch();
    const onDeleteSensor = useCallback((sensor_id) => {
        dispatch(send_z3k_command(device_id, sensor_id, 'RemoveObject', null, null, false));
    }, [dispatch, device_id]);
    const [ConfirmDialog, openConfirmDialog] = useConfirmDialog();
    const [onClickId, setOnClickId] = useState(null);
    const [sensor_type, setSensorType] = useState(ClimaticDigitalSensorType.WIRED);
    const _openConfirmDialog = useCallback((sensor_id, sensor_type) => {
        setOnClickId(sensor_id);
        setSensorType(sensor_type);
        openConfirmDialog();
    }, [setOnClickId, openConfirmDialog, setSensorType]);
    const deleteSensor = useCallback(() => {
        if (onClickId) {
            onDeleteSensor(onClickId);
            replace_config({
                ...config,
                radiosensors: (config.radiosensors ?? []).filter((sensor) => sensor.id !== onClickId),
            });
        }
    }, [sensor_settings, deleted_sensor_ids, onDeleteSensor, onClickId]);
    const titleElem = (_jsxs(Box, { display: "flex", justifyContent: "space-between", children: [_jsx(Typography, { variant: "inherit", fontWeight: "inherit", children: "\u0420\u0430\u0434\u0438\u043E\u0434\u0430\u0442\u0447\u0438\u043A\u0438" }), _jsx(RadioRegistrationButton, { enabled: device?.online ?? false, device_id: device_id, module_id: radiomodule?.id, module_state: get_z3k_object_state(z3k_state, radiomodule?.id) })] }));
    return (_jsxs(Box, { display: "flex", flexDirection: "column", sx: { gridRowGap: '1em', px: '16px' }, children: [radiomodule != null && (_jsx(SettingCard, { title: titleElem, children: _jsx(SensorsTable, { sensors: (config.radiosensors || []).map((radiosensor) => {
                        const settings = sensor_settings.get(radiosensor.id);
                        return (settings ??
                            default_settings_from_sensor(radiosensor, ClimaticDigitalSensorType.RADIO, circuit_options));
                    }), predicate: (sensor) => sensor.type == ClimaticDigitalSensorType.RADIO, onDelete: _openConfirmDialog }) })), _jsx(SettingCard, { title: "\u041F\u0440\u043E\u0432\u043E\u0434\u043D\u044B\u0435 \u0434\u0430\u0442\u0447\u0438\u043A\u0438", children: _jsx(SensorsTable, { sensors: (config.wired_temperature_sensors || [])
                        //.filter(({id}) => !deleted_sensor_ids.has(id))
                        .map((sensor) => {
                        const settings = sensor_settings.get(sensor.id);
                        return (settings ??
                            default_settings_from_sensor(sensor, ClimaticDigitalSensorType.WIRED, circuit_options));
                    }), predicate: (sensor) => sensor.type == ClimaticDigitalSensorType.WIRED, onDelete: _openConfirmDialog }) }), _jsx(ConfirmDialog, { onConfirm: deleteSensor, children: sensor_type == ClimaticDigitalSensorType.RADIO
                    ? 'Чтобы подключить его заново, потребуется физический доступ к датчику'
                    : 'Чтобы вернуть датчик, достаточно будет подключить его к прибору' })] }));
}
ClimaticDigitalSensors.isWarning = () => false;
ClimaticDigitalSensors.isError = (validation_result) => {
    const radiosensors_validation = unpack_validation(validation_result, 'radiosensors');
    return (radiosensors_validation instanceof Array &&
        radiosensors_validation.some((item, index) => !!unpack_validation(radiosensors_validation, index, 'name')));
};
ClimaticDigitalSensors.isShown = (is_service_view, config, spec, is_staff, is_climatic) => {
    return is_service_view && is_climatic;
};
